import React from 'react';
import HamburgerIcon from '../../Shared/UI/HamburgerIcon/components/HamburgerIcon';
import { useHeaderActions } from './HeaderContext';
import styles from './SmallScreenHeaderNav.module.scss';

const SmallScreenHeaderNav = () => {
  const { openNavigationMenu } = useHeaderActions();

  return (
    <button 
      className={styles.hamburgerButton}
      onClick={() => {
        openNavigationMenu('root');
      }}
      aria-label="Toggle navigation menu"
      type="button"
    >
      <HamburgerIcon />
    </button>
  );
};

export default SmallScreenHeaderNav;
